var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "body-container", attrs: { id: "cookie" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isShow,
            expression: "isShow"
          }
        ],
        staticClass: "body-content"
      },
      [
        _vm.cookie_diaVisited
          ? _c("div", { staticClass: "detail_con" }, [
              _c("div", { staticClass: "cookie_title" }, [
                _vm._v("\n        Cookie Preferences\n        "),
                _c(
                  "span",
                  { staticClass: "closeBtn", on: { click: _vm.closeDio } },
                  [_vm._v("X")]
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "dia_but" }, [
                _c(
                  "span",
                  { staticClass: "btn1", on: { click: _vm.Required_Only } },
                  [_vm._v("Required Only")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "btn2", on: { click: _vm.accept_all } },
                  [_vm._v("Accept All")]
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.footer_diaVisited
          ? _c("div", { staticClass: "footer_con" }, [
              _c("div", { staticClass: "headerTest" }, [
                _vm._v("\n        We Value Your Privacy\n        "),
                _c(
                  "span",
                  { staticClass: "morenBtn", on: { click: _vm.Required_Only } },
                  [_vm._v("X")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer_text" }, [
                _vm._v(
                  "\n        We use  cookies to maintain the essential functionality of our website and\n        detect website performance to help us improve our website and online products and services, as well as improving your experience by providing personalized content.\n        You can manage your settings at any time through "
                ),
                _c(
                  "span",
                  { staticClass: "clicksty", on: { click: _vm.preferClick } },
                  [_vm._v("Cookie Preferences")]
                ),
                _vm._v(" or read our "),
                _c(
                  "span",
                  { staticClass: "clicksty", on: { click: _vm.privacyBtn } },
                  [_vm._v("Cookie Policy")]
                ),
                _vm._v(" to learn more.\n      ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "footer_but" }, [
                _c(
                  "span",
                  { staticClass: "btn1", on: { click: _vm.preferClick } },
                  [_vm._v("Cookie Preferences")]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "btn2", on: { click: _vm.accept_all } },
                  [_vm._v("Accept All")]
                )
              ])
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cookie_three" }, [
      _c("div", { staticClass: "content" }, [
        _vm._v(
          "Cookies are small files which, when placed on your device, enable us to provide certain features and functionality of CZUR websites and online services to you. We use the following types of cookies on our websites. View Cookie Policy for full details."
        ),
        _c("br")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "headerTitle" }, [
        _c("i", { staticClass: "icon-dui" }),
        _c("span", { staticClass: "headerTest" }, [
          _vm._v("Strictly Necessary Cookies")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          "These cookies are essential for you to use our websites, such as the cookies used for carrying out the transmission of a communication, the cookies that record requests for information from the Internet and block web attacks so as to ensure web security, the cookies that are strictly necessary for us to provide information society services that you request. You must accept strictly necessary cookies to be able to use our websites."
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "headerTitle" }, [
        _c("i", { staticClass: "icon-cuo" }),
        _c("span", { staticClass: "headerTest" }, [
          _vm._v("Preference Cookies")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._v(
          'These cookies are also known as "functionality cookies", these cookies allow us to remember choices you have made through your use of our websites, what region you are in, or what your username and password are so you can automatically log in. These cookies can help us reallocate work load among our servers and enable our webpages to respond faster.'
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "headerTitle" }, [
        _c("i", { staticClass: "icon-cuo" }),
        _c("span", { staticClass: "headerTest" }, [
          _vm._v("Statistics Cookies")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content lastContent" }, [
        _vm._v(
          'These cookies are also known as "performance cookies", these cookies collect information about how you use our websites, like which web pages you visited and which links you clicked on. These cookies can help us to improve your browsing experience on our websites.'
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17010274", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17010274","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cookie.vue
// module id = null
// module chunks = 